import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div>
  <se-po-membership-list [personaId]="personaId">
  </se-po-membership-list>
</div>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class MembershipListExampleComponent {

  constructor() {
  }

}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-membership-list-example',
  template,
  styleUrls: ['./membership-list-docs.component.scss'],
  standalone: false,
})
export class MembershipListExampleComponent extends SeFeDocsExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public personaId = 59707602

  constructor() {
    super()
  }
}
